export default __webpack_public_path__ + "ff152b075739ee63a3031c5cc93f4175.png";